import ROUTES from '../../constants/routes';
import KLogo from './assets/klogo.webp';
import KLogoNoText from './assets/klogo_no_text.webp';

const HEADER = {
    NAV_ITEMS: [
        {
            page: "About",
            link: ROUTES.ABOUT_SITE
        },
        // {
        //     page: "About Me",
        //     link: ROUTES.ABOUT_ME
        // },
        {
            page: "History",
            link: ROUTES.HISTORICAL_TIMELINE
        },
        // {
        //     page: "Frameworks",
        //     link: ROUTES.FRAMEWORKS
        // },
        // {
        //     page: "Projects",
        //     link: ROUTES.PROJECTS
        // },
        {
            page: "Credentials",
            link: ROUTES.CREDENTIALS
        },
        // {
        //     page: "Skills",
        //     link: ROUTES.SKILLS
        // }
    ],
    LOGOS: {
        LOGO: KLogo,
        LOGO_NO_TEXT: KLogoNoText
    }
}

export default HEADER;